import { apiClient } from './apiClient';
import { BlogListResponse, BlogDetailResponse } from '../types/blog';

export async function getBlogPosts(
  page = 1,
  limit = 10,
  tag?: string,
): Promise<BlogListResponse> {
  const params: Record<string, string> = {
    page: String(page),
    limit: String(limit),
  };
  if (tag) params.tag = tag;

  const response = await apiClient.get<BlogListResponse>('/blog', { params });
  return response.data;
}

export async function getBlogPost(slug: string): Promise<BlogDetailResponse> {
  const response = await apiClient.get<BlogDetailResponse>(`/blog/${slug}`);
  return response.data;
}
